import Vue from 'vue'
import VueRouter from 'vue-router'
import Logon from '@/web/Logon.vue'
import Temporary from '@/web/Temporary.vue'
import DeepSeekAi from '@/web/DeepSeekAi.vue'
import DeepSeekApp from '@/web/DeepSeekApp.vue'


import BookNow from '@/app/BookNow.vue'
import WardrobeClean from '@/app/WardrobeClean.vue'
import SuccessNow from '@/app/SuccessNow.vue'
import LoveNow from '@/app/LoveNow.vue'
import AIchat from '@/app/AIs/AIchat.vue'
import Questionnaire from '@/app/Questionnaire.vue'
import TangYing from '@/app/TangYing.vue'


Vue.use(VueRouter)

const routes = [
    // WEB
    {path: '/', component: Logon}, // 登录页面
    {path: '/web/temporary', component: Temporary}, // 临时接单页面
    {path: '/web/deepseekai', component: DeepSeekAi},
    {path: '/web/deepseekapp', component: DeepSeekApp}, // AI 适配

    // APP
    {path: '/app/booknow', component: BookNow}, // 预约页面
    {path: '/app/successnow', component: SuccessNow}, // 预约成功页面
    {path: '/app/wardrobeclean', component: WardrobeClean}, // 预约页面
    
    

    // 其他项目
    {path: '/app/lovenow', component: LoveNow}, // 好玩页面
    {path: '/app/tangying', component: TangYing}, // 好玩页面
    {path: '/app/aichat', component: AIchat}, // 手机 ai 聊天
    {path: '/app/questionnaire', component: Questionnaire}, // 预约页面

]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
